import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import MealListItem from "components/foodItem/MealListItem"
import { useSetPageTitle } from "libs/ga"
import { FlexBox } from "components/Common/FlexBox"
import { DotLoading, InfiniteScroll, SpinLoading } from "antd-mobile"
import NoSuggestionMeal from "components/Icons/NoSuggestionMeal"
import { MealType } from "model/food/types"
import useLogMealFromMeal from "features/meal/hooks/logMeal/useLogMealFromMeal"
import styled from "styled-components"
import { useSetMealTypeParams } from "features/meal/hooks"

const NoSuggestions = () => {
  return (
    <FlexBox
      $direction="column"
      $alignItems="center"
      $justify="center"
      style={{ paddingTop: 48 }}
      $gap={24}
    >
      <NoSuggestionMeal />

      <p style={{ textAlign: "center", color: "#1C1F21", fontSize: 16 }}>
        You haven’t logged any meal yet. Let’s start logging your first.
      </p>
    </FlexBox>
  )
}

const InfinitiScrollContent = ({
  isFirstLoad,
  isLoading,
  hasMore,
}: {
  isFirstLoad: boolean
  isLoading: boolean
  hasMore: boolean
}) => {
  if (isFirstLoad) {
    return (
      <FlexBox $alignItems="center" $justify="center" style={{ height: 200 }}>
        <SpinLoading />
      </FlexBox>
    )
  }

  if (hasMore) {
    return isLoading ? (
      <FlexBox
        style={{ height: 40, width: "100%" }}
        $justify="center"
        $alignItems="center"
      >
        {" "}
        <span>Loading more food</span>
        <DotLoading />
      </FlexBox>
    ) : null
  }

  return "All foods found"
}

const Wrapper = styled.div`
  height: 100%;
  overflow: hidden;
`

const Title = styled.div`
  line-height: 22px;
  padding: 8px;
  font-size: 14px;
  font-weight: 700;
  padding: 0 var(--app-horizontal-padding);
`

const RecentMealsContent = styled.div`
  --title-height: 22px;
  overflow-y: auto;
  height: calc(100% - var(--title-height));
  padding: 0 var(--app-horizontal-padding);
`

const RecentMeals = ({
  meals,
  isNoSuggestedMeals,
  loadMore,
  loading,
  hasMore,
  recentMealsRef: recentMealsRef,
  onSelectMeal,
}: {
  meals: MealType[]
  isNoSuggestedMeals: boolean
  loadMore: any
  loading: boolean
  hasMore: boolean
  recentMealsRef: React.RefObject<HTMLDivElement>
  onSelectMeal: (meal: MealType) => void
}) => {
  useSetPageTitle("Recent Meals")

  const { handleLogMealFromMeal } = useLogMealFromMeal()
  const { mealTypeValue } = useSetMealTypeParams()

  if (isNoSuggestedMeals) {
    return <NoSuggestions />
  }

  return (
    <Wrapper>
      <Title>Recent</Title>
      <RecentMealsContent ref={recentMealsRef}>
        {meals.map((meal, index) => (
          <div key={meal.id}>
            {" "}
            <MealListItem
              onSelect={() => onSelectMeal(meal)}
              meal={meal}
              onAdd={(meal) => {
                handleLogMealFromMeal({ ...meal, type: mealTypeValue })
              }}
            />
            {index !== meals.length - 1 && <FoodListDivider />}
          </div>
        ))}
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
          <InfinitiScrollContent
            hasMore={hasMore}
            isLoading={loading}
            isFirstLoad={!meals.length}
          />
        </InfiniteScroll>
      </RecentMealsContent>
    </Wrapper>
  )
}

export default RecentMeals
